<template>
	<v-card outlined>
		<v-card-text>
			<v-row>

				<template
					v-for = "(item_field, idx_info) of info_fields"
				>
					<v-col>
						<v-card
							v-if 	= "item_field.type == 'switch'"
							outlined
							class  	= "pa-0"											
						>
						
							<v-switch
								dense 
								hide-details
								v-if 		= "item_field.type == 'switch'"
								class   	= "pa-0 my-2 ml-2"
								:label 		= "$ml.get(item_field.text)"
								v-model 	= "info[item_field.key]"		
								@click 		= "save(false, item_field.key)"	
								:disabled 	= "!show.edit_action"
							></v-switch>
							
						</v-card>
						<v-text-field
							dense
							outlined
							hide-details							
							:type 	  		= "item_field.type"
							v-else-if 		= "['text'].includes(item_field.type)"
							:placeholder 	= "item_field.placeholder"
							v-model   		= "info[item_field.key]"
							:label 	  		= "$ml.get(item_field.text)"
							:suffix 		= "item_field.suffix"
							
						></v-text-field>

						<v-text-field
							dense
							outlined
							hide-details							
							:type 	  		= "item_field.type"
							v-else-if 		= "['number'].includes(item_field.type)"
							:placeholder 	= "item_field.placeholder"
							v-model.number	= "info[item_field.key]"
							:label 	  		= "$ml.get(item_field.text)"
							:suffix 		= "item_field.suffix"
							@change 		= "actions(item_field.action,info[item_field.key])"
							
						></v-text-field>
						
					</v-col>
				</template>
				<v-col
					cols = "12"

				>
					<v-data-table
						dense
					    fixed-body
					    fixed-header
						v-show  			 = "false"
						:headers 			 = "header_table"
						:items 				 = "render_list"
						class 				 = "elevation-5"
						:options.sync 		 = "options"
					   	:server-items-length = "total"
					   	:footer-props 		 = "{
					   		showFirstLastPage 	: true,
					   		itemsPerPageOptions : [15, 30],
					   		showCurrentPage 	: true,
					   		itemsPerPageText 	: ''
					   	}"
					   	loading-text 		 = "Loading... Please wait"
					   	:loading 			 = "loading"
					    item-key 			 = "index"
					    :height 			 = "layout_height + 'px'"
					>
					    <!-- rowsPerPageText: [30] -->
					    <template v-slot:item.actions="{ item }" >
							<v-btn
								x-small
								color  = "primary"
								@click = "actions('edit', item)"
							>
								<v-icon
									x-small
									v-text = "'mdi-pencil'"
								></v-icon>
							</v-btn>	
							<v-btn
								x-small
								color  = "error"
								@click = "actions('confirm_delete', item)"
								class  = "mx-1"
							>
								<v-icon
									x-small
									v-text = "'mdi-delete'"
								></v-icon>
							</v-btn>							
						</template>

					    <template v-slot:top>
					    	<v-toolbar
					    		flat
					    		dense
					    	>
					    		<!-- <v-toolbar-title> -->
					    			<v-text-field 
							        	dense
							        	outlined
							        	v-model 	 = "search" 
							        	:label 		 = "$ml.get('search')" 
							        	class 		 = "mx-4 pt-1 " 
							        	append-icon  = "mdi-magnify" hide-details
							        	@input 		 = "v => { search = v.toUpperCase() }"
							        	@click 		 = "keyboard_is_active()"
							        	@keyup.enter = "get_search(search)"
							        	
							        ></v-text-field>
							        <input 
										dark
							        	type 	= "" 
							        	name 	= ""
							        	@input 	= "onInputChange"
										:value 	= "input"
										class 	= "input"
										v-show 	= "false"
							        >
							        	
						        	<v-bottom-sheet 
						        		dark
						        		inset 
						        		v-model = "sheet" 
						        	>					    
									    <v-sheet 
									    	height = "300px" 
									    	class  = "pa-1"
									    >
								        	<SimpleKeyboard 
									        	@onChange 	=	"onChange" 
									        	@onKeyPress = "onKeyPress" 
									        	:input 		= "search" 
									        	:theme 		= "theme"
								        	/>
									    </v-sheet>
								    </v-bottom-sheet>  
					    		<!-- </v-toolbar-title> -->
					    		<!-- <v-spacer></v-spacer> -->
					    	 	<v-divider
						          	inset
						          	vertical
						          	class 	= "mx-4"
						        ></v-divider>
					    		
					    		<v-spacer></v-spacer>
					    		<v-dialog 
					    			v-model 	= "dialog"
					    			max-width 	= "500px"
					    		>
					    			
						    		<template v-slot:activator="{ on, attrs }">
						    			<v-btn
						    				dark
						    				small
						    				color 	= "primary"
						    				class 	= "mx-2"
						    				v-bind 	= "attrs"
						    				v-on 	= "on"
						    				v-text 	= "'New'"
						    			></v-btn>	
						    		</template>
						    		<v-card outlined>
						    			<v-card-title
						    				class = "primary pa-1 body-2"
						    			>
						    				<v-icon
						    					x-small
						    					color = "white"
						    					class = "mx-1"
						    				>
						    					mdi-new-box
						    				</v-icon>
						    				<span
						    					v-text = "title"
						    				></span>
						    				<v-spacer></v-spacer>
						    				<v-icon
						    					small
						    					color  = "error"
						    					v-text = "'mdi-close'"
						    					@click = "dialog = false"
						    				></v-icon>
						    			</v-card-title>
						    			<v-card-text>
						    				<template
						    					v-for = "(item_field,  idx_field) of fieds_table"

						    				>
						    					<v-text-field
													dense
						    						outlined
													hide-details
						    						v-if 	= "item_field.type == 'text' || item_field.type == 'number'"
						    						:key 	= "idx_field"
													:label 	= "$ml.get(item_field.text)"
													v-model = "info[item_field.key]"
													:type 	= "item_field.type"
													class 	= "mx-2 my-2"
						    						:placeholder = "item_field.placeholder"
						    					></v-text-field>

						    					<v-select
						    						dense
						    						outlined
						    						hide-details
						    						v-else-if 	= "item_field.type == 'select'"
						    						:label		= "$ml.get(item_field.text)"
						    						v-model 	= "info[item_field.key]"
						    						:items 		= "item_field.list"
						    						class 		= "mx-2 my-2"
						    					></v-select>
						    				</template>
						    			</v-card-text>
						    			<v-divider></v-divider>
						    			<v-card-actions>
						    				<v-spacer></v-spacer>
						    				<v-btn
						    					x-small
						    					color  = "primary"
						    					v-text = "$ml.get('save')"
						    					@click = "actions('add')"
						    				></v-btn>
						    				<v-btn
						    					x-small
						    					color  = "error"
						    					v-text ="$ml.get('close')"
						    					@click = "dialog = false"
						    				></v-btn>
						    			</v-card-actions>
						    		</v-card>
					    		</v-dialog>
					    	</v-toolbar>		   
					    	
					    </template>
						
					</v-data-table>
				</v-col>

				<!-- Actions add peripherals -->
				<v-col
					cols = "12"
				>
					<v-data-table
						dense
					    fixed-body
					    fixed-header
						
						:headers 			 = "header_table_dev"
						:items 				 = "render_list_dev"
						class 				 = "elevation-5"
						:options.sync 		 = "options_dev"
					   	:server-items-length = "total_dev"
					   	:footer-props 		 = "{
					   		showFirstLastPage 	: true,
					   		itemsPerPageOptions : [15, 30],
					   		showCurrentPage 	: true,
					   		itemsPerPageText 	: ''
					   	}"
					   	loading-text 		 = "Loading... Please wait"
					   	:loading 			 = "loading_dev"
					    item-key 			 = "index"
					    :height 			 = "layout_height + 'px'"
					>
					    <!-- rowsPerPageText: [30] -->
					 	<template 
					 		v-for 	= "head of header_table_dev"
					 		v-slot:[`header.${head.value}`] = "{ header }"
					 	>
					 		{{ $ml.get(head.text) }}
					 	</template>
					    <template v-slot:item.options = "{ item, index }" >
							<v-btn-toggle mandatory>
								<v-btn
									x-small
									color  = "primary"
									@click = "actions('edit_dev', item, index)"
									v-show = "show.edit_action"
								>
									<v-icon
										x-small
										v-text = "'mdi-pencil'"
									></v-icon>
								</v-btn>	
								<v-btn
									x-small
									color  = "error"
									@click = "actions('confirm_delete_dev', item)"
									class  = "mx-1"
									v-show = "show.delete_action"
								>
									<v-icon
										x-small
										v-text = "'mdi-delete'"
									></v-icon>
								</v-btn>
							</v-btn-toggle>							
						</template>


					    <template v-slot:top>
					    	<v-toolbar
					    		flat
					    		dense
					    	>
					    		<!-- <v-toolbar-title> -->
					    			<v-text-field 
							        	dense
							        	outlined
							        	v-model 	 = "search_dev" 
							        	:label 		 = "$ml.get('search')" 
							        	class 		 = "mx-4 pt-1 " 
							        	append-icon  = "mdi-magnify" hide-details
							        	@input 		 = "v => { search_dev = v.toUpperCase() }"
							        	@click 		 = "keyboard_is_active()"
							        	@keyup.enter = "get_search_dev(search_dev)"
							        	
							        ></v-text-field>
							        <input 
										dark
							        	type 	= "" 
							        	name 	= ""
							        	@input 	= "onInputChange"
										:value 	= "input"
										class 	= "input"
										v-show 	= "false"
							        >
							        	
						        	<v-bottom-sheet 
						        		dark
						        		inset 
						        		v-model = "sheet" 
						        	>					    
									    <v-sheet 
									    	height = "300px" 
									    	class  = "pa-1"
									    >
								        	<SimpleKeyboard 
									        	@onChange 	= "onChange" 
									        	@onKeyPress = "onKeyPress" 
									        	:input 		= "search_dev" 
									        	:theme 		= "theme"
								        	/>
									    </v-sheet>
								    </v-bottom-sheet>  
					    		<!-- </v-toolbar-title> -->
					    		<!-- <v-spacer></v-spacer> -->
					    	 	<v-divider
						          	inset
						          	vertical
						          	class 	= "mx-4"
						        ></v-divider>
					    		
					    		<v-spacer></v-spacer>
				    			<v-btn
				    				dark
				    				small
				    				color 	= "primary"
				    				class 	= "mx-2"
				    				@click  = "actions('new_action')"
				    				v-text 	= "$ml.get('new')"
				    				v-show 	= "show.add_action"
				    			></v-btn>	
					    		<v-dialog 
					    			v-model 	= "dialog_dev"
					    			max-width 	= "500px"
					    		>
					    			
						    		<!-- <template v-slot:activator="{ on, attrs }"> -->
						    				<!-- v-bind 	= "attrs"
						    				v-on 	= "on" -->
						    		<!-- </template> -->
						    		<v-card outlined>
						    			<v-card-title
						    				class = "primary pa-1 body-2"
						    			>
						    				<v-icon
						    					x-small
						    					color = "white"
						    					class = "mx-1"
						    				>
						    					mdi-new-box
						    				</v-icon>
						    				<span
						    					v-text = "title_dev"
						    				></span>
						    				<v-spacer></v-spacer>
						    				<v-btn 
										        x-small         
										        icon 
										        class  = "error"
										        @click = "actions('close_dev')"          
										     
										    >
							    				<v-icon
							    					x-small
							    					color  = "white"
							    					v-text = "'mdi-close'"
							    					
							    				></v-icon>
						    				</v-btn>
						    			</v-card-title>
						    			<v-card-text>
						    				<template
						    					v-for = "(item_field_dev,  idx_field_dev) of fieds_table_dev"
						    					v-if  = "item_field_dev"
						    				>
						    					<v-text-field
													dense
						    						outlined
													hide-details
						    						v-if 	= "item_field_dev.type == 'text' || item_field_dev.type == 'number'"
						    						:key 	= "idx_field_dev + '_text'"
													:label 	= "$ml.get(item_field_dev.text)"
													v-model = "info_dev[item_field_dev.key]"
													:type 	= "item_field_dev.type"
													class 	= "mx-2 my-2"
						    						:placeholder = "item_field_dev.placeholder"
						    						:disabled 	 = "item_field_dev && item_field_dev.disabled"
						    						v-show 		 = "show[item_field_dev.key]"
						    					></v-text-field>

						    					<v-select
						    						dense
						    						outlined
						    						clearable
						    						hide-details
						    						v-else-if 	= "item_field_dev.type == 'select'"
						    						:label		= "$ml.get(item_field_dev.text)"
						    						v-model 	= "info_dev[item_field_dev.key]"
						    						:items 		= "render_lists(item_field_dev.list)"
						    						class 		= "mx-2 my-2"
						    						@change 	= "render_shows(item_field_dev.key)"
						    						v-show 		= "show[item_field_dev.key]"						    					
						    						:value 		= "item_field_dev.defaultValue"	
						    						:item-value = "item_field_dev.value_item"
													:item-text  = "item_field_dev.key_item"
													:return-object = "item_field_dev.return_obj"
						    					:key 	= "idx_field_dev + '_select'"
						    					></v-select>
						    					<v-card 
													:key="idx_field_dev + '_slide'"
													outlined 
													class 		= "pa-0 caption pb-0 mx-2" 
													height 		= "40"
													v-show 		= "show[item_field_dev.key]"
													v-else-if 	= "item_field_dev.type == 'slide'"
												>
						    						<v-slider
							    						dense							    						
							    						v-show 		= "show[item_field_dev.key]"	
							    						:label 		= "$ml.get('volumen')"
							    						v-model 	= "info_dev[item_field_dev.key]"
														max 		= "100"
														min 		= "0"
														:prepend-icon 	= " info_dev[item_field_dev.key] > 80 ? 'mdi-volume-high' : 80  >= info_dev[item_field_dev.key]  && info_dev[item_field_dev.key] >= 30 ? 'mdi-volume-medium' : 'mdi-volume-low'"
														:thumb-size="24"
          												thumb-label="always"
													></v-slider>
												</v-card>
						    					<v-card 
													:key="idx_field_dev + '_switch'"
													outlined 
													class 		= "pa-0 caption pb-0 mx-2" 
													height 		= "40"
													v-show 		= "show[item_field_dev.key]"
													v-else-if 	= "item_field_dev.type == 'switch'">
													<v-switch			
														dense						
														hide-details
														class 			= "mt-1 ml-1 "			
														v-model 		= "info_dev[item_field_dev.key]"									
														:label 			= "$ml.get(item_field_dev.text)"
														:prepend-icon 	= "item_field_dev.icon"
														:true-value 	= "item_field_dev.value"
													></v-switch>
														
												</v-card>
						    				</template>
						    			</v-card-text>
						    			<v-divider></v-divider>
						    			<v-card-actions>
						    				<v-spacer></v-spacer>
						    				<v-btn
						    					x-small
						    					color  = "primary"						    					
						    					@click = "actions('save_dev')"
						    				>
						    					{{ $ml.get(action_dev) }}
						    				</v-btn>
						    				<v-btn
						    					x-small
						    					color  = "error"
						    					v-text = "$ml.get('close')"
						    					@click = "actions('close_dev')"
						    				></v-btn>
						    			</v-card-actions>
						    		</v-card>
					    		</v-dialog>
					    	</v-toolbar>		   
					    	
					    </template>
						
						<template
							v-for = "(item_opt, idx_opt) of head_options_dev"
							v-slot:[`item.${item_opt.key}`] = "{ item, index }"
						>
							<v-btn
								small
								:key 	= "ID_notification + idx_opt"									
								:color 	= "item[item_opt.key] ? 'primary' : 'secondary'"
								@click 	= "actions(item_opt, item, index)"
								
							>
								{{ item[item_opt.key] ? $ml.get('on') : $ml.get('off') }}
							</v-btn>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
		
	</v-card>
</template>
<script>
	import EventBus from '@/event-bus'

	export default{
		name: 'alarm_actions',
		props:['info_to_component'],
		data: (vm) => ({
			info 	 	: {				
				ismodal 		: true,
				isnotificable 	: true,
				issendtows 		: true,
				issendemail 	: true,
				issound 		: true,
				timeout 		: 5,

			},
			info_fields : [
				{
					text : "popup",
					key  : "ismodal",
					type : "switch",
					
				},
				{
					text : "notifiable",
					key  : "isnotificable",
					type : "switch",
					
				},
				{
					text : "send_ws",
					key  : "issendtows",
					type : "switch",
					
				},
				{
					text : "send_email",
					key  : "issendemail",
					type : "switch",
					
				},
				{
					text : "sound",
					key  : "issound",
					type : "switch",
					
				},
				{
					text : "alert_time",
					key  : "timeout",
					type : "number",
					suffix : "seg",
					action : "changed_timeout",
				},
				{
					text : "alert",
					key  : "isalert",
					type : "switch",
					
				},
				{ 
					text : "require_confirmation",
					key  : "manual_confirmation",				
					type : "switch",				
				},
			], 
			info_id  	 : null, 
			title 		 : 'new',
			header_table : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: 'Tag', value: 'tag' },
				{ text: 'Active', value: 'active' },
				// { text: vm.$ml.get('actions'), value: 'actions' },
			],
			fieds_table  : [
				{ 
					text : 'name',
					key  : "name",
					type : "text",
				},
				{ 
					text : "tag",
					key  : "tag",
					type : "select",
					list : [
						'person',
						'gun',
						'lpr',
						'objects',
						'motion',
						'anomalies'
					]
				},
				
				{ 
					text : "terms",
					placeholder: "Select number to activate alarm",
					key  : "terms",
					type : "number",
				}
			],
			options 		:{ itemsPerPage: 30},
			total 			: 1,
			layout_height 	: 200,
			list 			: [],
			loading 		: false,
			search 			: null,
			input 			: '',
			theme 			: 'hg-theme-default myTheme1', // myTheme1
			sheet 			: false,
			is_open_modal 	: false,
			dialog 			: false,

			title_dev 		 : vm.$ml.get("new"),
			info_dev 		 : { },
			item_dev 		 : null, 
			header_table_dev : [
				{ text: 'device', value: 'name' },
				{ text: 'type', value: 'type' },
				{ text: 'action', value: 'action' },
				{ text: 'destiny', value: 'destiny' },
				{ text: 'activeOn', value: 'activeOn' },					
				{ text: 'smart_event', value: 'smart_event' },
				// { text: vm.$ml.get('manual_confirmation'), value: 'manual_confirmation' },
				{ text: 'delay', value: 'delay' },
				{ text: 'seconds', value: 'seconds' },
				{ text: 'pin', value: 'pin' },
				{ text: 'value', value: 'value' },
				{ text: 'url', value: 'endpoint' },
				{ text: 'options', value: 'options' },
			],
			options_dev 	 : { itemsPerPage : 30 },
			total_dev 		 : 0,
			loading_dev 	 : false,
			search_dev 		 : "",
			dialog_dev 		 : false,
			fieds_table_dev  : [
				{ 
					key  : "type",
					text : "typeAction",
					placeholder: "",
					type : "select",
					list : "listTypeAction",
					key_item 	: "text", 					
					value_item  : "key",
					show : true,
					// return_obj 	: true,
				},
				{ 
					text : 'device',
					key  : "deviceId",
					type : "select",
					list : "renderDevices",
					show : true,
					key_item 	: "name", 
					value_item  : "deviceId",
					return_obj 	: true,
				},
				// { 
				// 	text : "type",
				// 	key  : "type",
				// 	type : "text",
				// 	disabled : true,
				// 	show : true,
					// list : "list_type_dev",					
				//},

				/*{ 
					text : "manual_confirmation",
					placeholder: "",
					key  : "manual_confirmation",
					type : "switch",
					show : true,
				},*/
				{ 
					key  : "action",
					text : "action",
					placeholder: "",
					type : "select",
					list : "list_action_dev",
					show : true,
					return_obj 	: true,

				},
				{
					text 		: "destiny",
					key  		: "destiny",
					type 		: "select",
					list 		: "list_destinys",
					key_item 	: "text", 
					value_item  : "key",
					show 		: false,
					return_obj 	: false,
				},
				{
					text 		: "activeOn",
					key  		: "activeOn",
					type 		: "select",
					list 		: "list_activeOn",
					key_item 	: "text", 
					value_item  : "key",
					defaultValue 	: "successfully", 
					show 		: false,
					return_obj 	: false,
				},
				{
					text : "delay",
					key  : "delay",
					type : "number",
					show : false,
				},
				{
					text : "seconds",
					key  : "seconds",
					type : "number",
					show : false,
				},
				{
					text : "pin",
					key  : "pin",
					type : "number",
					show : false,
				},
				{
					text : "value",
					key  : "value",
					type : "text",				
					show : false,
				},
				{
					text : "url",
					key  : "endpoint",
					type : "text",					
					show : false,
				},
				{
					text : "frequency",
					key  : "frequency",
					type : "number",					
					show : true,
				},
				{
					text 		: "actionsRing",
					key  		: "actionRing",
					type 		: "select",
					list 		: "listActionsRing",
					key_item 	: "text", 
					value_item  : "key",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text 		: "file",
					key  		: "file",
					type 		: "select",
					list 		: "listFilesRing",
					key_item 	: "text", 
					value_item  : "key",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text 		: "mode",
					key  		: "mode",
					type 		: "select",
					list 		: "listModeRing",
					key_item 	: "text", 
					value_item  : "key",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text : "count",
					key  : "count",
					type : "number",					
					show : false,
				},
				{
					text : "volumen",
					key  : "volumen",
					type : "slide",
					min : 0,
					max : 100,					
					show : false,
				},
				{
					text 		: "smart_event",
					key  		: "smart_event",
					type 		: "select",
					list 		: "renderListSmartEvent",
					key_item 	: "name", 
					value_item  : "id",
					show 		: false,
					isMultiple 	: true,
				},
			],
			list_action_dev 	: [ ], 
			list_action_dev_opt : {
				device 		: ["snapshot", "record", "webhook"], // IP_CAM
				peripheral 	: ["blink" , "send_value","sera4", "webhook", "ring"], // PERIPHERAL
				system : ["change_smart_event_status", "connect","start_counter","end_counter"]

			},
			show 				: {
				add_action  	: true,
				edit_action 	: true,
				delete_action 	: true,
				smart_event		: false,
			},
			action_dev 	 		: 'save',
			item_info   		: null,
			action_info 		: "", 
			ID_notification 	: 'alarms_table_action',
			bus 				: {},
			list_dev 			: [],
			// disableds 		: {},
			head_options_dev 	: [
				/*{
					key 	: "manual_confirmation",
					action  : "change_value_table",

				}*/
			],
			list_destinys  		: [
				{
					text 	: vm.$ml.get("final_client"),
					key 	: "final_client",
				},
				{
					text 	: vm.$ml.get("monitor"),
					key 	: "monitor",
				}
			],
			
			defaultValueRing : {
				action : "",
				file : "",
				mode : "",
				count : 0, 
				volumen: 0,
			},
			listActionsRing : [
				{ key : 'start', text : vm.$ml.get("start") }, 
				{ key: 'stop', text : vm.$ml.get("stop")}
			],
			listFilesRing :[
				{ key: 'userfile1', text : "userfile1" },
				{ key: 'userfile2', text : "userfile2" },
				{ key: 'userfile3', text : "userfile3" },
				{ key: 'userfile4', text : "userfile4" },
				{ key: 'userfile5', text : "userfile5" },
				{ key: 'userfile6', text : "userfile6" },
				{ key: 'userfile7', text : "userfile7" },
				{ key: 'userfile8', text : "userfile8" },
				{ key: 'userfile9', text : "userfile9" },
				{ key: 'userfile10', text : "userfile10" },

			],
			listModeRing : [
				{ key: 'once', text : vm.$ml.get("once") },
				{ key: 'multiple', text : vm.$ml.get("multiple") }, 
				{ key: 'duration', text : vm.$ml.get("duration") }
			],
			listTypeAction : [
				{ key :  "device", text : vm.$ml.get("device")},
				{ key :  "peripheral", text : vm.$ml.get("peripheral")},
				{ key :  "system", text : vm.$ml.get("system")},
			],
			list_activeOn :[
				{ text 	: vm.$ml.get("successfully"), key 	: "successfully",},
				{ text 	: vm.$ml.get("unsuccessfully"), key 	: "unsuccessfully",},
			],


		}), // data

		created(){
			let info_local = this.$Helper.get_local("action_alarm");
			
			// console.log(this.info_to_component, "ACTIONS")
			if (this.info_to_component && this.info_to_component.default && this.info_to_component.default.actions && this.info_to_component.default.actions.id) {

				// console.log(this.info_to_component, "ACTIONS 2")
				this.render_info(this.info_to_component);
				this.render_devices_action();
				
			}else{
				const { timeout } = this.$Format.get_list("PARAMETERS");
				if (info_local) {
					this.info = {				
						ismodal 		: true,
						isnotificable 	: true,
						issendtows 		: true,
						issendemail 	: true,
						issound 		: true,
						isalert  		: false,
						timeout 		: timeout || 5,

					};//info_local;
				}
			}
			this.render_shows_created();
			let modul = this.$store.getters["auth/permission"](this.$route.name || "smart_event", "", "smart_event");
			if (modul) {
				if (!modul.can_add) {
					this.show.add_action = false;
				}
				if (!modul.can_edit) {
					this.show.edit_action = false;					
				}
				if (!modul.can_delete) {
					this.show.delete_action = false;					
				}
			} 
		}, // created

		watch:{
			options: {
				handler(){
					// this.get_list();
				}, deep: true,
			}, // options

			dialog: function(val){
				if (!val) {
					this.info = {};
				}
			}, // dialog

			info_to_component : function(val){
				if (val) {
					this.render_info(val);
				}
			}, // info_to_component

		}, // watch


		computed:{
			render_list: function(){
				return this.list;
			},
			render_list_dev: function(){
				return this.list_dev;
			}, 
			renderDevices(){
				let typeTemp = "";
				// Si es system + (start_counter o acciones que empiecen con end_), filtrar solo cámaras (IP_CAM)
				if(this.info_dev && this.info_dev.type == "system" && 
				   (this.info_dev.action == "start_counter" || (this.info_dev.action && this.info_dev.action.startsWith("end_")))){
					typeTemp = "IP_CAM";
				}else if(this.info_dev && this.info_dev.type && this.info_dev.type){
					typeTemp = this.info_dev.type == "peripheral" ? "PERIPHERAL" : "IP_CAM";
				}
				return this.$store.getters["Devices/list"].filter(x => x && x.type == typeTemp )
			},
			renderListSmartEvent(){				
				return this.$SmartEvent.getListSmartEvent();
			}

		}, // computed

		methods : {
			actions(act, item, opt){				
				if (act == 'add') {
					this.save();
				}
				if (act == 'edit') {

					this.title 	 = 'edit';
					this.info 	 = item;
					this.info_id = this.list.indexOf(this.info);
					this.dialog  = true;
				}
				if (act == 'confirm_delete') {
					EventBus.$emit('notifications_modal', {
						type: act,
						ID: this.ID_notification, 
					})
				}
				if (act == 'delete'){
					this.delete();
				}
				if ( act == 'save_dev') {
					if (this.action_dev == 'save') {						
						this.save_dev();
					}else{
						this.update_dev();


					}
				}
				if (act == 'edit_dev') {
					this.info_dev 	 = item;
					this.item_info	 = opt;		
					this.dialog_dev  = true;
					this.action_dev  = "update";					
					if (this.info_dev.action == 'ring') {
						this.info_dev = this.renderToFormatRing(this.info_dev);
					}		    		
		    		if (this.info_dev.type && this.list_action_dev_opt[this.info_dev.type]) {
    					this.list_action_dev = this.list_action_dev_opt[this.info_dev.type];
    				}else{
    					console.warn("No find option select in device ", this.info_dev.type)
    				}	
					this.render_shows("type");
		    		//this.render_shows('action');
				}

				if (act == "new_action") {					
					this.info_dev 	= {};
					this.render_shows("type");
		    		// this.render_shows('action');					
					this.dialog_dev = true;
				}


				if ( act == "confirm_delete_dev") {
					EventBus.$emit('notifications_modal', {
						type: 'confirm_delete',
						ID: this.ID_notification, 
					})

					this.info_dev 	 = item;
					this.item_info	 = opt;
					this.action_info = "delete_dev";
				}
				if (act == 'close_dev') {
					// dialog_dev = false
					this.dialog_dev 	= false;
					this.info_dev   	= {};
					this.action_dev  	= "save";
					this.render_shows("type");
		    		// this.render_shows('action');

				}else 
				if( act && act.action == "change_value_table"){
					item[act.key] =  !item[act.key];
				}else if(act == "changed_timeout"){
					this.save(false);
				}
			}, // actions

			renderToFormatRing(item){
				if (item && item.value && typeof item.value == "string" ) {
					const tempRing = this.$Helper.to_object(item.value);
					console.log(" VALUE ", tempRing)
					if (tempRing) {
						let actionRing = tempRing.action;
						delete tempRing.action;
						item = { 
							...item, 
							actionRing, 
							...tempRing
						}
					}
				}
				return item
			},

			render_info(item){
				if (item){
					if (item.default && item.default.actions) {
						this.info = item.default.actions;

					}
				}
			}, // render info

			render_devices_action(){
				if (this.info && this.info.detail_action_device && this.info.detail_action_device.length > 0) {
					this.info.detail_action_device.forEach((dev) => {
						if (dev) {
							let temp = this.$Format.render_device(dev.deviceId);
							if (temp) {
								dev.name = temp.name;
							}else{
								dev.name = this.$ml.get("not_found_device");
							}
						}
					});
					this.list_dev  = [ ...this.info.detail_action_device ];
					this.total_dev = this.list_dev.length;
				}
			}, // render devices action

			render_lists(list){
				if (list == 'devices') {
					return this.$store.getters["Devices/list"];
				}else
				if (this[list]) {
					return this[list];
				}
				return [];
			}, // render lists

			get_list(){
				const { itemsPerPage, page } = this.options;
				let pg = 1, 
					sw = 0;

				this.loading = true;

				if ( itemsPerPage == 15 ) {
					if (page % 2 == 0) {
						pg = (page / 2);
						sw = 2;
					}else{
						pg = parseInt(page / 2) + 1;
						sw = 1;
					}
				}else{
					pg = page
				}
				const api = this.$URL + '/api/v1/alarm/?page=' + pg;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'Get list');
					let items  = res.data.rows;

					this.total = parseInt(res.data.count);
					
					if (itemsPerPage <= 15) {
						items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
					}
					
					this.list = items;
					this.loading = false;

				}).catch( er => {
					console.log(er, 'Error get list');
					this.loading = false;
					if (er && er.message == 'Network Error') {
						EventBus.$emit('notifications_modal', {
							type 	: 'error',
							message : er.message 

						})
					}
					// this.get_local();
				})
			}, // get list

			save(is_local = true, key){
				if (!this.$store.getters["auth/permission"](this.$route.name || "smart_event", "can_edit", "smart_event")) {
					this.$EventBus.$emit("notifications_modal",{
						type 		: "warning",
						message 	: this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("smart_event")
					});
					
					return false
				}
					console.log(" Actions ", is_local, this.info)
				if (!is_local){
					let temp_action = { ...this.info };					
					this.$Helper.set_local("action_alarm", temp_action);
					// update
					if (this.info && this.info.id) {
						console.log(" Actions 1 update" )
						
						const api = this.$URL + '/api/v1/alarm/action/' + this.info.id;
						this.$axios.put(api, this.info).then( res => {
							this.$emit('info_component', {
								act 	: 'render_compt',
								opt 	: 'actions',
								value 	: this.info,
							});
							this.$EventBus.$emit("notifications_modal",{
								type 	: 'updated',
								message : this.$ml.get('actions')
							})
						}).catch( er => {
							console.log("Error update action ", er);
						})

					}else{
						this.$emit('info_component', {
							act 	: 'render_compt',
							opt 	: 'actions',
							value 	: this.info,
						})
					}
				}else{

					const info_table = this.info;
					let list_temp  	 = this.list; 
					let msg  		 = 'saved';

					
					/*
					this.$nextTick(()=>{

					if (this.title == 'new') {
						list_temp.push(info_table);
						this.total++;
						
					}else{
						list_temp[this.info_id] = info_table;
						msg = 'updated'
						this.title = 'new';
					}
					EventBus.$emit('notifications_modal', {
							type: msg,						
						})
					this.list = list_temp;
					this.dialog = false;
					})
						*/
					this.info 		= {};
				}
				
			}, // save

			delete(){
				this.list.splice(this.info_id, 1);
				if (this.info_id == 0) {
					this.list = [];
				}
				EventBus.$emit('notifications_modal',{
					type: 'deleted'
				});
			}, // delete

			onChange(input) {
		      	this.input  = input;
		      	this.search = input.toUpperCase();
		    },
		    onKeyPress(button) {			    
			    if (button=='{enter}') {
			      	this.get_search(this.search);
			    }
		    },
		    onInputChange(input) {
		      	this.input = input.target.value;
		      
		    },
		    keyboard_is_active(){
		    	let key_board=false;
		    	if (localStorage.getItem('virtual_Key_board')) {
					key_board=JSON.parse(localStorage.getItem('virtual_Key_board'));
				}
			
		    	if (key_board==true) {
		    		this.sheet=true;
		    
		    	}
		    
		    },	

		    render_shows(key){ 				
				if( key == "type"){
					this.show.action = false;
					this.show.deviceId = false;
					this.show.type = true;
					this.$set(this.show, 'smart_event', false);
					this.show.activeOn = false;
					let {type} 	= this.info_dev;
					if(type == "system"){
						this.show.action  	= true;
						this.info_dev.type = "system";						
						this.list_action_dev = this.list_action_dev_opt["system"];
						// Solo asignar valor por defecto si no existe (evita sobrescribir al editar)
						this.info_dev.action = this.info_dev.action || "change_smart_event_status";
						// Si la acción es start_counter o empieza con end_, mostrar deviceId para seleccionar cámaras
						if (this.info_dev.action == "start_counter" || (this.info_dev.action && this.info_dev.action.startsWith("end_"))) {
							this.show.deviceId = true;
							this.$set(this.show, 'smart_event', false);
						} else {
							this.show.deviceId = false;
							// Mostrar smart_event por defecto para system (se ocultará si se cambia a start_counter o end_)
							this.$set(this.show, 'smart_event', true);
						}
						this.show.delay  	= true;
						this.show.activeOn = true;
						
					}else if(type == "device"){
						this.list_action_dev = this.list_action_dev_opt["device"];
						this.show.action = true;
						this.show.deviceId = true;
						this.show.activeOn = true;
						//this.show.type = true;
						
					}else if(type == "peripheral"){
						this.list_action_dev = this.list_action_dev_opt["peripheral"];
						this.show.action = true;
						this.show.deviceId = true;
						this.show.activeOn = true;
						//this.show.type = true;
					}
					this.render_shows("action");
					
				}else
		    	if (key == 'action') {
		    		let type 	= this.info_dev.type;
		    		let action 	= this.info_dev['action']; 
		    		this.show.delay 	= false;
	    			this.show.pin 		= false; 
	    			this.show.value 	= false; 
	    			this.show.seconds 	= false; 
	    			this.show.destiny  	= false;
		    		this.show.endpoint 	= false;
		    		this.show.actionRing 	= false;
					this.show.file 			= false;
					this.show.mode 			= false;
					this.show.count			= false;
					this.show.volumen 		= false;
					this.show.activeOn 		= false;
					this.info_dev.activeOn = this.info_dev.activeOn ? this.info_dev.activeOn : "successfully";
		    		if (type == 'device') {
						this.show.activeOn = true;
		    			if (action == 'snapshot') {
		    				this.show.delay 	= true; 
							this.show.endpoint = true;
							

		    			}else
		    			if (action == 'record') {
		    				this.show.delay  = true; 
		    				this.show.seconds = true; 
							this.show.endpoint = true;

		    			}else{
		    				this.show.delay  	= false;
		    				this.show.seconds 	= false;
		    				this.show.pin 		= false; 
		    				this.show.value 	= false; 
							this.show.endpoint = true;

		    			}

		    		}else if(type == "peripheral"){
						this.show.activeOn = true;
						this.show.frecuency = true
		    			if (action == 'blink') {
		    				this.show.delay = true; 
		    				this.show.pin 	= true; 
		    				this.show.value = false;
							this.show.destiny 	= true;
		    				this.show.endpoint 	= true; 
		    				this.show.seconds 	= true;


		    			}else
		    			if (action == 'send_value') {
		    				this.show.delay = true; 
		    				this.show.pin 	= true; 
		    				this.show.value = true;
							this.show.destiny 	= true;
		    				this.show.endpoint 	= true;
		    				this.show.seconds 	= true;
		    			}else
		    			if (action == 'ring') {		    		
			    			this.show.destiny 		= true;
			    			this.show.endpoint 		= false;		
				    		this.show.actionRing 	= true;
							this.show.file 			= true;
							this.show.mode 			= true;							
							this.show.count			= true;
							this.show.volumen 		= true;
		    			}else
						if (action == "webhook"){
							this.show.destiny 	= true;
		    				this.show.endpoint 	= true; 
						}
		    		}else if(type == "system"){
						this.show.activeOn = true;
						// Ocultar smart_event cuando la acción es start_counter o empieza con end_
						if (action == 'start_counter' || (action && action.startsWith("end_"))) {
							this.$set(this.show, 'smart_event', false);
							// Mostrar deviceId para seleccionar cámaras cuando es start_counter o end_*
							this.show.deviceId = true;
							console.log('Setting smart_event to false, current value:', this.show.smart_event);
						} else {
							this.$set(this.show, 'smart_event', true);
							// Ocultar deviceId para otras acciones de system
							this.show.deviceId = false;
							console.log('Setting smart_event to true, current value:', this.show.smart_event);
						}
		    		}
		    	}else if (key == "deviceId") {
		    		if (this.info_dev) {
		    			if (this.info_dev.deviceId) {		    			
		    				if (this.info_dev.type != this.info_dev.deviceId.type) {
		    					this.show.delay 	= false;
				    			this.show.pin 		= false; 
				    			this.show.value 	= false; 
				    			this.show.seconds 	= false; 
				    			this.show.destiny  	= false;
				    			this.show.endpoint	= false;
					    		this.show.actionRing 	= false;
								this.show.file 			= false;
								this.show.count			= false;
								this.show.volumen 		= false;
								this.show.activeOn = true;

		    				}
		    				// this.info_dev.type = this.info_dev.deviceId.type;
		    				this.info_dev.name = this.info_dev.deviceId.name;
		    				// if (this.info_dev.type && this.list_action_dev_opt[this.info_dev.type]) {
		    				// 	this.list_action_dev = this.list_action_dev_opt[this.info_dev.type];
								
		    				// }else{
		    				// 	console.warn("No find option select in device ", this.info_dev.type)
		    				// }
		    			}
		    		}
		    	}
		    }, // render shows

		    render_shows_created(){
		    	this.fieds_table_dev.forEach((dev)=>{
		    		this.show[dev.key] = dev.show;
		    		if (this.info_dev) {
		    			if (this.info_dev[dev.key]) {
		    				this.show[dev.key] = true; 
		    			}
		    		}

		    		
		    	})
		    }, // render_shows_created

		    formatJsonRing(item){
		    	return this.$Helper.to_string({
		    		action : item.actionRing,
		    		file : item.file,
					mode : item.mode,
					count : item.count, 
					volumen: item.volumen,

		    	})
		    },

		    save_dev(){
		    	if (this.info_dev) {
	    			if (this.info_dev.action == 'ring') {
	    				this.info_dev.value = this.formatJsonRing(this.info_dev);
	    			}
		    		if (this.info && this.info.id) {
		    			let info_up 						 = this.info_dev;
		    			info_up.Detail_action_device_alarmId = this.info.id;
		    			info_up.name 					 	 = info_up && info_up.deviceId && info_up.deviceId.name ?  info_up.deviceId.name : info_up.name ;
		    			info_up.deviceId 					 = info_up && info_up.deviceId && info_up.deviceId.deviceId ?  info_up.deviceId.deviceId : info_up.deviceId ;
		    			this.loading_dev 					 = true;
		    			const api = this.$URL + "/api/v1/alarm/action/device";
		    			this.$axios.post(api, info_up).then(res => {
		    				this.loading_dev = false;
		    				this.dialog_dev  = false;
		    				res.data.name 	 = info_up.name;
		    				this.list_dev.push(res.data); 
		    				this.send_to_alarm();		    			
		    				this.info_dev 	 = {}; 
		    				this.total_dev 	 = this.list_dev.length ;

		    			}).catch( er => {
		    				this.loading_dev = false;
		    				console.log("Error create action device ", er)
		    			})

		    		}else{
		    			console.log("***************************** \n", this.info_dev)

		    			if (this.info_dev && this.info_dev.deviceId && this.info_dev.deviceId.deviceId) {
		    				this.info_dev.name 	   = this.info_dev.deviceId.name;
		    				this.info_dev.deviceId = this.info_dev.deviceId.deviceId;
		    			}
		    			this.list_dev.push({...this.info_dev });
		    			this.total_dev   = this.list_dev.length;
		    			this.info_dev 	 = {}; 
		    			this.dialog_dev  = false;
		    			this.send_to_alarm();

		    			// this.$emit("action_device", [ ...this.list_dev ]);
		    		}

		    	}
		    }, // save dev

		    update_dev(){
		    	if (this.info_dev) {
		    		if (this.info_dev.action == 'ring') {
	    				this.info_dev.value = this.formatJsonRing(this.info_dev);
	    			}
		    		if (this.info_dev.id) {
		    			let info_up 	 = this.info_dev;
		    			info_up.name 	 = info_up && info_up.deviceId && info_up.deviceId.name ?  info_up.deviceId.name : info_up.name ;
		    			info_up.deviceId = info_up && info_up.deviceId && info_up.deviceId.deviceId ?  info_up.deviceId.deviceId : info_up.deviceId ;

		    			this.loading_dev = true;
		    			
		    			const api = this.$URL + "/api/v1/alarm/action/device/" + info_up.id;

		    			this.$axios.put(api, info_up).then(res => {
		    				this.loading_dev = false;
		    				this.dialog_dev  = false;
		    				this.info_dev.name 	 = info_up && info_up.name ? info_up.name : null;
		    				// this.list_dev[this.item_info] = { ...this.info_dev };
		    				this.list_dev.splice(this.item_info, 1, { ...this.info_dev });
		    				this.info_dev = {};
		    				this.send_to_alarm();
		    				this.info_dev 	 = {}; 
							this.action_dev  = "save";

		    			}).catch( er => {
		    				this.loading_dev = false;
		    				console.log("Error create action device ", er)
		    			})
		    		}else{
		    			if (this.info_dev && this.info_dev.deviceId && this.info_dev.deviceId.deviceId) {
		    				this.info_dev.name 		= this.info_dev.deviceId.name;
		    				this.info_dev.deviceId 	= this.info_dev.deviceId.deviceId;
		    			}
		    			this.list_dev.splice(this.item_info, 1, { ...this.info_dev });
		    			this.info_dev 	 = {};
		    			this.dialog_dev  = false;
						this.action_dev  = "save";

		    			// this.$emit("action_device", [ ...this.list_dev ]);
		    			this.send_to_alarm();

		    		}
		    	}

		    }, // update dev

		    delete_dev(){
		    	if (this.info_dev) {
		    		if (this.info_dev.id) {
		    			let info_up 		= this.info_dev;
		    			this.loading_dev 	= true;
		    			const api = this.$URL + "/api/v1/alarm/action/device/" + info_up.id;
		    			this.$axios.delete(api).then( res => {
		    				this.loading_dev = false;
		    				this.list_dev.splice(this.item_info, 1);
		    				this.info_dev 	 = {};
		    				this.total_dev 	 = this.list_dev.length ;

		    				this.send_to_alarm();
		    			}).catch(er => {
		    				this.loading_dev = false;
		    				console.log("error delete action device ", er);
		    			})
		    		}else{
		    			this.list_dev.splice(this.item_info, 1);
		    			this.total_dev = this.list_dev.length ;
		    			this.info_dev  = {};
		    			this.send_to_alarm();

		    		}

		    	}
		    }, // delete dev

		    send_to_alarm(){
		    	this.info.detail_action_device = this.list_dev;
		    	this.$emit('info_component', {
					act 	: 'render_compt',
					opt 	: 'actions',
					value 	: this.info,
				});
		    	this.render_shows('action'); // hide the options

		    }, // send to alarm

		},// methods


		mounted(){
			let temp = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp, this.bus[temp] =(action) =>{
				if (action) {
					if (this.action_info == "delete_dev") {
						this.delete_dev();
					}else{a
						this.actions('delete');
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, "smart_event_actions")
		}, 
	};
</script>